import { useEffect } from 'react'
import { useAnnoncestore } from 'src/store/search'
import { Pagination, Card, Col, Button, Row, Spin, Tag } from 'antd'
import { PhotoProvider, PhotoView } from 'react-photo-view'
import { useParams } from 'react-router-dom'
import { Preloader } from 'src/components/preloader'
import { useAuthStore } from 'src/store/auth'
import 'react-photo-view/dist/react-photo-view.css'
import { Link } from 'react-router-dom'

export const UserAnnonces = () => {
  const { userId } = useParams()

  const { detailsData, isLoading, detailsPagination, onSearchDetails } =
    useAnnoncestore((store) => store)

  const { setActiveKeyMainMenu } = useAuthStore((store) => store)

  useEffect(() => {
    onSearchDetails(userId, 1)
    setActiveKeyMainMenu('mainMenu2')
  }, [])

  const getType = (el) => {
    switch (el) {
      case 'buying':
        return 'Ask'
      case 'selling':
        return 'Sell'
      default:
        return el || '-'
    }
  }

  return (
    <div>
      <h1>User annonces</h1>
      <div style={{ position: 'relative', padding: '20px 0' }}>
        {isLoading ? <Preloader /> : null}
        {detailsData
          ? detailsData.map((photo) => (
              <Card key={photo?.id} style={{ margin: '10px 0' }}>
                <Row>
                  <Col
                    xs={24}
                    md={6}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <div>
                      <p style={{ paddingBottom: 5 }}>
                        ID: <Tag color='red'>{photo?.id || '-'}</Tag>
                      </p>
                      <p style={{ paddingBottom: 5 }}>
                        Created at:{' '}
                        <Tag color='green'>
                          {photo?.readable_created_at || '-'}
                        </Tag>
                      </p>
                      <p style={{ paddingBottom: 5 }}>
                        Updated at:{' '}
                        <Tag color='cyan'>
                          {photo?.readable_updated_at || '-'}
                        </Tag>
                      </p>
                      {/* <Link to={`${photo?.id}`}>
                        <Button style={{ marginTop: 10 }} type='primary'>
                          Details
                        </Button>
                      </Link> */}
                    </div>
                  </Col>
                  <Col
                    xs={24}
                    md={6}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexDirection: 'column'
                    }}
                  >
                    <p>Photo: </p>
                    {photo?.photos?.data?.[0] ? (
                      <PhotoProvider>
                        <div>
                          {photo?.photos?.data.map((item) => (
                            <PhotoView key={item?.id} src={item?.thumb_l}>
                              <img
                                style={{ maxWidth: 100, maxHeight: 100, margin: 5 }}
                                src={item.thumb_m}
                                alt={item?.id}
                              />
                            </PhotoView>
                          ))}
                        </div>
                      </PhotoProvider>
                    ) : (
                      '-'
                    )}
                  </Col>
                  <Col
                    xs={24}
                    md={6}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <div>
                      <p style={{ paddingBottom: 5 }}>
                        Status:{' '}
                        <Tag
                          color={`${
                            photo?.status === 'active' ? 'lime' : 'red'
                          }`}
                        >
                          {photo?.status || '-'}
                        </Tag>
                      </p>
                      <p style={{ paddingBottom: 5 }}>
                        Type: <Tag color='green'>{getType(photo?.type)}</Tag>
                      </p>
                      <p style={{ paddingBottom: 5 }}>
                        Category:{' '}
                        <Tag color='blue'>{photo?.category?.title || '-'}</Tag>
                      </p>
                      <p style={{ paddingBottom: 5 }}>
                        Category EN:{' '}
                        <Tag color='blue'>
                          {photo?.category?.title_en || '-'}
                        </Tag>
                      </p>
                      <p style={{ paddingBottom: 5 }}>
                        Super-deal:{' '}
                        <Tag color='pink'>
                          {photo?.super_deal ? 'active' : 'disabled'}
                        </Tag>
                      </p>
                      <p>Description:</p>
                      <p>
                        <b>{photo?.description || '-'}</b>
                      </p>
                    </div>
                  </Col>
                </Row>
              </Card>
            ))
          : null}
      </div>
      {detailsPagination ? (
        <Pagination
          defaultCurrent={1}
          current={detailsPagination?.current_page}
          total={detailsPagination?.total}
          pageSize={detailsPagination?.per_page}
          onChange={(newPage) => onSearchDetails(userId, newPage)}
          showTotal={(total, range) => `${range[0]}-${range[1]} of ${total}`}
        />
      ) : null}
    </div>
  )
}
